'use client'

import {getInjection} from '@runlab/di'
import React, {useMemo, useState} from 'react'
import {LayoutEventTypes} from '@/src/core/domain/events/layout.events'
import Modal from '@/src/shared/ui/modal'
import {ProfileEventTypes} from '@/src/core/domain/events/profile.events'

interface ChangeProfileModalProps extends React.PropsWithChildren {
  open: boolean
  onClose?: () => void
  profileForm: React.ReactNode
}

export const ChangeProfileContainer = ({
  children,
  profileForm,
}: React.PropsWithChildren & {profileForm: React.ReactNode}) => {
  const [open, setOpen] = useState(false)

  useMemo(() => {
    const eventBus = getInjection('IEventBus')

    eventBus.subscribe(LayoutEventTypes.UserNotHaveRequirementFields, () => setOpen(true))
    eventBus.subscribe(ProfileEventTypes.FormFilled, () => setOpen(false))

    return eventBus
  }, [])

  return (
    <ChangeProfileModal open={open} onClose={() => setOpen(false)} profileForm={profileForm}>
      {children}
    </ChangeProfileModal>
  )
}

export const ChangeProfileModal = ({open, onClose, children, profileForm}: ChangeProfileModalProps) => (
  <>
    {children}
    <Modal
      title="Заполните профиль пользователя"
      open={open}
      onCancel={onClose}
      onClose={onClose}
      closable={false}
      maskClosable={false}>
      {profileForm}
    </Modal>
  </>
)
